import HomeView from "./homeView.js";
import CoursesView from "./coursesView.js";
import WebinarView from "./webinarView.js";

HomeView.appearOnScroll();
HomeView.contactUsBtn();
HomeView.mobileMenu();

CoursesView.scaleCards();
CoursesView.faq();
CoursesView.courseCardObserver();
CoursesView.dotDetector();

// WebinarView.displayEntryPage();
WebinarView.displayQuotes();
